<template>
  <div class="wgtSettings" :class="{ 'isTableShown': isShowTable }">
    <div class="cardR">
      <div class="boxR">
        <div class="myZoomClass" :class="$store.state.TClrs" id="treeviewsnap">
          <div class="content-panel1 controlht" v-show="IstreeErr">
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ PersonaName }}</h2>
            <apiErrorComponent @tryReload="tryReload" :compTitle="PersonaName" compId="treeviewsnap">
            </apiErrorComponent>
          </div>
          <div class="content-panel1 controlht" v-show="!IstreeErr">
            <div class="insideL  hide-on-presentation ">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-bars" />
              </div>
              <div class="contents">
                <span v-show="!IstreeErr">
                  <font-awesome-icon :icon="['fas', 'eye']" title="Show Blank Values"
                    v-on:click="isRemoveBlank = !isRemoveBlank; swapTreeMap()" v-if="isRemoveBlank" />
                  <font-awesome-icon :icon="['fas', 'eye-slash']" title="Hide Blank Values"
                    v-on:click="isRemoveBlank = !isRemoveBlank; swapTreeMap()" v-else />
                  <font-awesome-icon icon="fa-solid fa-diagram-successor" title="Switch to Alternate View"
                    v-on:click="swapCharts()" />
                  <font-awesome-icon icon="fa-solid fa-table" v-on:click="showTable()"
                    :title="isShowTable ? 'Hide Table' : 'Show Table'" />
                  <font-awesome-icon icon="fa-solid fa-chalkboard-teacher" title="Add to Storyboard"
                    v-on:click="addToSlider()" />
                  <font-awesome-icon icon="fa-solid fa-file-download" title="Download Widget"
                    v-on:click="downloadDom()" />
                  <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" v-on:click="downIns()" />
                </span>
              </div>
            </div>
            <div class="insideR hide-on-presentation">
              <div class="icon">
                <font-awesome-icon icon="fa-solid fa-info" />
              </div>
              <div class="contents">
                {{ infoMsgI }} You can click on individual boxes in Unnested TreeMap view to get more
                insights.<br /><br />
                Actions you can take on this widget: <br />
                <ul>
                  <li>Click on
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye']" /> to see non blank
                    values and
                    <font-awesome-icon class="actIcon" :icon="['fas', 'eye-slash']" /> to see blank
                    values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-diagram-successor" /> to
                    swap between
                    Nested and Unnested TreeMap view
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-table" /> to see table with
                    values
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-chalkboard-teacher" /> to
                    add to
                    storyboard
                  </li>
                  <li>Click on
                    <font-awesome-icon class="actIcon" icon="fa-solid fa-file-download" /> to
                    download the chart
                    with current insight
                  </li>
                  <li>Click on
                    <font-awesome-icon icon="fa-solid fa-file-export" title="Export Insights" /> to
                    download all the
                    insights
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="!isPersonaLoaded">
              <widgetLoadingComp></widgetLoadingComp>
            </div>
            <div v-show="isPersonaLoaded"></div>
            <h2 class="chartTitle hide-on-presentation themeclr2">{{ PersonaName }}</h2>
            <div class="panel-body text-center" id="myPanelBody">
              <div v-show="istreemapshw" id="treeMapChart"
                style="height:415px;width: 100%;margin-top: -15px;margin-bottom: 10px;">
              </div>
              <div v-if="isShowTable">
                <div v-on:click="onBtnExport()" class="myfaBtn spl">
                  <font-awesome-icon :icon="['fas', 'fa-download']" />
                </div>
                <ag-grid-vue style="width: 96%;height:470px;"
                  class="table-striped thmHead myMttrTbl v01 ag-theme-alpine myHomeTable" :columnDefs="asgcolsDefs"
                  @grid-ready="onAsgReady" :modules="modules">
                </ag-grid-vue>
              </div>
              <div v-if="IstreeData" class="widgetError text-center">
                <widgetDataMsg></widgetDataMsg>
              </div>
              <widgetsSlider :insideArr="treeMapinsight" :isInsErr="IstvInsErr" :isErr="IstreeErr"
                :compTitle="PersonaName" compId="treeviewsnap"></widgetsSlider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var myChartDD;
function reportWindowSizeTM() {
  if (myChartDD != undefined) {
    myChartDD.resize()
  }
}
import {
  useRoute
} from 'vue-router';
import * as echarts from 'echarts';
import domtoimage from "dom-to-image-more";
import {
  saveAs
} from 'file-saver';
import {
  AgGridVue
} from "@ag-grid-community/vue3";
import {
  ClientSideRowModelModule
} from "@ag-grid-community/client-side-row-model";
import {
  CsvExportModule
} from "@ag-grid-community/csv-export";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import widgetDataMsg from '../smallcomp/chartDataMsg.vue'
import widgetLoadingComp from '../smallcomp/widgetloader.vue'
import screenShotMix from "../../mixin/screenShotMix";
import apiErrorComponent from '../smallcomp/apierror.vue'
import widgetsSlider from '../smallcomp/widgets-slider.vue';
export default {
  name: 'TreeMap',
  mixins: [screenShotMix],
  components: {
    widgetLoadingComp,
    widgetDataMsg,
    AgGridVue,
    apiErrorComponent,
    widgetsSlider
  },
  props: {
    getpass: String,
    getPins: Object,
    tabname: String,
  },
  data() {
    return {
      modules: [ClientSideRowModelModule, CsvExportModule],
      asgLisApi: null,
      asgLis: null,
      asgcolsDefs: [],
      isShowTable: false,
      isRemoveBlank: false,
      isNested: true,
      enbNested: false,
      isPersonaLoaded: false,
      istreemapshw: false,
      PersonaName: "",
      infoMsgI: "",
      IstreeData: false,
      IstreeErr: false,
      IstvInsErr: false,
      treeData_nBlank: [],
      treeData_Blank: [],
      treeMapinsight: [],
      rootNode: {},
      selected: null,
      fieldHolder: [],
      margin: {
        top: 20,
        right: 0,
        bottom: 0,
        left: 0
      },
      wholechart: null,
      drillwidth: 960,
      drillheight: 530,
      paginNo: 0,
      paginIdx: "transform: translateX(0%)",
      isChartRedraw: true,
    }
  },
  methods: {
    pagNav(index) {
      this.paginNo = index;
      this.paginIdx = "transform: translateX(-" + 5 * index + "%)"
    },
    tryReload() {
      this.getPersona(this.getwgtCond)
    },
    addToSlider() {
      let insArr = this.treeMapinsight;
      let name = "Treemap View - " + this.getPins.viewName;
      let screenShort = {
        id: 'treeviewsnap',
        name: 'treeviewsnap.png'
      }
      this.addToSliderMix(screenShort, insArr, name)
    },
    onAsgReady(params) {
      this.asgLisApi = params.api
      this.gridColumnApi = params.columnApi
      this.asgLisApi.setRowData(this.asgLis);
      params.api.sizeColumnsToFit();
    },
    onBtnExport() {
      this.asgLisApi.exportDataAsCsv();
    },
    percGetter(params) {
      return params.data.Percentage + '%'
    },
    myPercComparator(v1, v2, n1, n2) {
      v1 = parseFloat(v1.slice(0, -1))
      v2 = parseFloat(v2.slice(0, -1))
      return v1 - v2
    },
    swapCharts() {
      this.isNested = !this.isNested
      this.swapTreeMap();
    },
    showTable() {
      if (this.isShowTable) {
        this.isShowTable = false
      } else {
        this.asgLis = [];
        for (var i = 0; i < this.wholechart[0].length; i++) {
          var element = this.wholechart[0][i]
          if (element.value != "") {
            var mySplit = element.id.split("=>")
            var eleTT
            eleTT = {
              "L1": mySplit[1],
              "L2": mySplit[2],
              "Ticket": element.value,
              "Percentage": element.perc
            };
            this.asgLis.push(eleTT)
          }
        }
        this.asgcolsDefs = [{
          headerName: this.fieldHolder[0],
          field: 'L1',
          sortable: true
        },
        {
          headerName: this.fieldHolder[1],
          field: 'L2',
          sortable: true
        },
        {
          headerName: 'Percentage',
          field: 'Percentage',
          sortable: true,
          type: 'numericColumn',
          comparator: this.myPercComparator,
          valueGetter: this.percGetter,
        },
        {
          headerName: '# Tickets',
          field: 'Ticket',
          type: 'numericColumn',
          sortable: true,
          cellRenderer: params => {
            return parseInt(params.value).toLocaleString();
          }
        }
        ]
        this.isShowTable = true;
      }
    },
    downloadDom() {
      let removeSpaceName = this.PersonaName.replace(/ /g, "_");
      let imgname = removeSpaceName + ".png"
      let widgetID = "treeviewsnap"
      var geticondiv = document.querySelectorAll('#treeviewsnap .insideL,#treeviewsnap .insideR, .hide-on-presentation')
      geticondiv.forEach(box => {
        box.style.opacity = 0;
      });
      document.getElementById(widgetID).classList.remove("myZoomClass")
      domtoimage.toBlob(document.getElementById(widgetID))
        .then(function (blob) {
          saveAs(blob, imgname)
          geticondiv.forEach(box => {
            box.style.opacity = 1;
          });
          document.getElementById(widgetID).classList.add("myZoomClass")
        })
    },
    downIns() {
      let fileName = this.PersonaName + '_Insights.txt'
      let insArr
      insArr = this.treeMapinsight.join("\r\n")
      var fileToSave = new Blob([insArr], {
        type: 'application/json',
        name: fileName
      });
      saveAs(fileToSave, fileName)
    },
    swapTreeMap() {
      var data2
      if (this.isRemoveBlank) {
        data2 = this.treeData_nBlank
      } else {
        data2 = this.treeData_Blank
      }
      var chartDomDD = document.getElementById('treeMapChart');
      if(chartDomDD == null) return;
      if (chartDomDD != null && chartDomDD != undefined) {
        var option;
        if (this.isChartRedraw) {
          this.isChartRedraw = false;
          myChartDD = echarts.init(chartDomDD, null, {
            renderer: 'svg',
            useDirtyRect: false
          });
        }
        if (this.isNested) {
          myChartDD.setOption(
            (option = {
              tooltip: {
                confine: true,
                formatter: function (info) {
                  var value = info.value;
                  var treePathInfo = info.treePathInfo;
                  var treePath = [];
                  for (var i = 1; i < treePathInfo.length; i++) {
                    treePath.push(treePathInfo[i].name);
                  }
                  return [
                    '<div class="tooltip-title">' +
                    echarts.format.encodeHTML(treePath.join('/')) +
                    '</div>',
                    '# Ticket: ' + echarts.format.addCommas(value)
                  ].join('');
                }
              },
              visualMap: {
                type: 'continuous',
                orient: 'vertical',
                text: ['High', 'Low'],
                left: 0,
                top: 0,
                calculable: false,
                min: 0,
                max: 1000,
                inRange: {
                  color: this.$store.state.chartColor,
                },
                textStyle: {
                  color: '#777',
                  fontSize: 10
                },
              },
              grid: {
                top: 10,
                bottom: 40,
                left: 120,
                right: 20
              },
              backgroundColor: 'transparent',
              series: [{
                name: data2.name,
                type: 'treemap',
                visibleMin: 300,
                width: '90%',
                height: '90%',
                top: 'top',
                left: 'right',
                roam: false,
                leafDepth: 2,
                label: {
                  position: 'insideTopLeft',
                  formatter: function (params) {
                    let lebPer = (params.value / params.treePathInfo
                      .reverse()[1].value) * 100;
                    return params.name + '\n' + params.value + '(' + Number
                      .parseFloat(lebPer).toFixed(2) + '%)'
                  },
                },
                upperLabel: {
                  show: true,
                  height: 25
                },
                emphasis: {
                  itemStyle: {
                    opacity: 1,
                  },
                },
                levels: [{
                  itemStyle: {
                    color: 'transparent',
                    opacity: 0.2,
                    borderColor: 'transparent',
                    borderWidth: 1,
                    gapWidth: 1
                  },
                  upperLabel: {
                    show: false
                  }
                },
                {
                  colorAlpha: [0.5, 0.75],
                  itemStyle: {
                    opacity: 0.75,
                    borderColorSaturation: 0.9,
                    borderWidth: 1,
                    gapWidth: 1
                  },
                },
                {
                  colorAlpha: [0.25, 0.5],
                  itemStyle: {
                    opacity: 0.75,
                    borderWidth: 1,
                    gapWidth: 1,
                    borderColorSaturation: 0.6,
                    borderRadius: 3,
                  }
                }
                ],
                data: data2.children
              }]
            })
          );
        } else {
          myChartDD.setOption(
            option = {
              tooltip: {
                confine: true,
                formatter: function (info) {
                  var value = info.value;
                  var treePathInfo = info.treePathInfo;
                  var treePath = [];
                  for (var i = 1; i < treePathInfo.length; i++) {
                    treePath.push(treePathInfo[i].name);
                  }
                  return [
                    '<div class="tooltip-title">' +
                    echarts.format.encodeHTML(treePath.join('/')) +
                    '</div>',
                    '# Ticket: ' + echarts.format.addCommas(value)
                  ].join('');
                }
              },
              visualMap: {
                type: 'continuous',
                orient: 'vertical',
                text: ['High', 'Low'],
                left: 0,
                top: 0,
                calculable: false,
                min: 0,
                max: 1000,
                inRange: {
                  color: this.$store.state.chartColor,
                },
                textStyle: {
                  color: '#777',
                  fontSize: 10
                },
              },
              grid: {
                top: 10,
                bottom: 40,
                left: 120,
                right: 20
              },
              backgroundColor: 'transparent',
              series: [{
                name: data2.name,
                roam: false,
                width: '90%',
                height: '90%',
                top: 'top',
                left: 'right',
                type: 'treemap',
                visibleMin: 300,
                data: data2.children,
                itemStyle: {
                  borderRadius: 5,
                  borderWidth: 2,
                  opacity: 1,
                  borderType: 'solid',
                  borderColorSaturation: 0.7
                },
                leafDepth: 1,
                label: {
                  position: 'insideTopLeft',
                  formatter: function (params) {
                    return params.name + ':' + params.value
                  },
                },
              }]
            }
          )
        }
      }
    },
    blank_iterate(leveldata) {
      for (var i = 0; i < leveldata.length; i++) {
        if (leveldata[i].name == "(Blanks)") {
          leveldata.splice(i, 1)
          i--
        } else {
          if (leveldata[i].children.length != 0) {
            this.blank_iterate(leveldata[i].children, i + 1)
          }
        }
      }
    },
    getPersona(valtype) {
      this.isPersonaLoaded = false
      this.IstreeErr = false
      this.IstreeData = false
      this.istreemapshw = false
      let cond
      if (valtype == 0 || valtype == 1) {
        cond = 0
        this.PersonaName = "Business Drilldown"
        this.infoMsgI = this.$parent.widgetInfo.Treeview_overall
      } else if (valtype == 4) {
        cond = 4
        this.PersonaName = "Assignment Group Drilldown"
        this.infoMsgI = this.$parent.widgetInfo.Treeview_reopen
      } else if (valtype == 6) {
        cond = 6
        this.PersonaName = "Automation Drilldown"
      } else {
        cond = 5
        this.PersonaName = "Assignment Group Drilldown"
        this.infoMsgI = this.$parent.widgetInfo.Treeview_reasg
      }
      this.axios.post(this.uriApiUrl + 'DataAnalysis/treeview?cond=' + cond + "&asg_id=" + this.asgId, {
        "selid": this.getPins.selid,
        "edited": this.getPins.edited
      },{
      headers: {
            'Content-Type': 'application/json'
          }})
        .then((response) => {
          if (response.status == 200) {
            if (response.data != "Error" && response.data != "Nodata") {
              var wholetreeresp = response.data
              this.wholechart = wholetreeresp.getree
              this.treeMapinsight = wholetreeresp.insights;
              this.fieldHolder = wholetreeresp.disp_col_list;
              this.treeData_nBlank = JSON.parse(JSON.stringify(this.wholechart[1]));
              this.treeData_Blank = JSON.parse(JSON.stringify(this.wholechart[1]));
              this.blank_iterate(this.treeData_nBlank.children)
              this.istreemapshw = true
              if (wholetreeresp.header != "Drilldown" && wholetreeresp.header != undefined) {
                this.PersonaName = wholetreeresp.header
              }
              if (this.treeMapinsight.length == 0) {
                this.IstvInsErr = true
              }
              if (this.isChartRedraw) {
                try {
                  echarts.dispose(myChartDD);
                } catch (error) {
                  // console.log("..")
                }
              }
              setTimeout(() => {
                this.swapTreeMap(false)
              }, 5)
            }
          } else if (response.data == "Nodata") {
            this.IstreeData = true
          } else if (response.data == "Error") {
            this.IstreeErr = true
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Treemap view. Try after sometime!'
            })
          }
          this.isPersonaLoaded = true
        }).catch((response) => {
          this.IstreeErr = true
          this.isPersonaLoaded = true
          if (this.enabledDebug == 1) {
            this.$notify({
              type: "error",
              text: 'Sorry! Something went wrong in Treemap view. Try after sometime!'
            })
          }
        })
    }
  },
  mounted() {
    const route = useRoute()
    this.asgId = route.params.asgid
    this.getPersona(this.getwgtCond)
    this.isChartRedraw = true
    window.addEventListener("resize", reportWindowSizeTM);
  },
  unmounted() {
    window.removeEventListener("resize", reportWindowSizeTM);
  },
  computed: {
    getwgtCond() {
      return this.$store.state.widgetCond
    }
  },
  watch: {
    '$store.state.chartColor': function () {
      if (myChartDD != undefined) {
        this.swapTreeMap()
      }
    }
  },
}
</script>
<style></style>